import './SeleccionTema.css'

function SeleccionTema (props) {

    return (
        <>
            <select className='select-tema' onChange={props.onCambiar} value={props.onLeccionASeleccionar}>
            {props.lecciones.map((leccion, index) => {                
                return (
                        <option key={leccion.titulo}>{leccion.titulo}</option>
                )  
            })}
            </select>
        </>
    )
}

export default SeleccionTema;